"use client";

export default function Footer() {
	return null;
}
